// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2XxQS","readditLink":"Navbar_readditLink__ZIdGE"};